import React from "react";
import { Router, Routes, Route, Navigate } from "react-router-dom";


// We import all the components we need in our app
import Navbar from "./components/navbar";
import CaseTiles from "./components/pages/CaseTiles";
import SouvenirPackageTiles from "./components/pages/SouvenirPackageTiles"
import CapsuleTiles from "./components/pages/CapsuleTiles"
import AboutPage from "./components/pages/About";
import Packages from "./components/pages/Packages";
import Capsules from "./components/pages/Capsules";
import Home from "./components/pages/Home";
import CaseDetailPage from "./components/pages/CaseDetailPage";
import SouvenirPackageDetailPage from "./components/pages/SouvenirPackageDetailPage"
import CapsuleDetailPage from "./components/pages/CapsuleDetailPage"
import { createContext, useState, useEffect } from "react";
import getUserInfo from "./utilities/decodeJwt";

export const UserContext = createContext();

const App = () => {
  const [user, setUser] = useState();

  useEffect(() => {
    setUser(getUserInfo());
  }, []);

  return (
    <>
      <Navbar />
      <UserContext.Provider value={user}>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/cases" element={<CaseTiles />} />
          <Route path="/packages" element={<SouvenirPackageTiles />} />
          <Route path="/capsules" element={<CapsuleTiles />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/cases/:caseName" element={<CaseDetailPage />} /> {/* dynamic route */}
          <Route path="/packages/:caseName" element={<SouvenirPackageDetailPage />} /> {/* dynamic route */}
          <Route path="/capsules/:caseName" element={<CapsuleDetailPage />} /> {/* dynamic route */}

        </Routes>
      </UserContext.Provider>
    </>
  );
};



export default App
